import { render } from "./upload-doc.vue?vue&type=template&id=df31a034&scoped=true"
import script from "./upload-doc.vue?vue&type=script&lang=js"
export * from "./upload-doc.vue?vue&type=script&lang=js"

import "./upload-doc.vue?vue&type=style&index=0&id=df31a034&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df31a034"]])

export default __exports__